import React from "react";
import {
    Tools,
} from "../components";
import '../index.scss';

function ToolsPage() {
    return (
        <Tools/>
    );
}

export default ToolsPage;